import { Component, OnInit, ViewChild, ViewEncapsulation, Input, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { TranslateService } from '../../../../../../services/translate.service';
import { UserService } from '../../../../../../services/user.service';

import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonMethods } from '../../../../../common/tools/commonMethods';
import { GridTools } from '../../../../../common/tools/gridTools';
import { ModalCommonComponent } from '../../../../../common/components/modal-common/modal-common.component';
import { WksCentralService } from '../../../../services/wks-central.service';
import { ParamActionsrefModel, ParamActionsref_sch, ParamActionsrefEvent } from '../../../../models/wks-param.model';

@Component({
  selector: 'mdi-actionsref-table',
  templateUrl: './actionsref-table.component.html',
  styleUrls: ['./actionsref-table.component.css']
})
export class ActionsrefTableComponent implements OnInit {

  displayType: string;
  optionItem: string;

  sidenavCollapsed: boolean;
  @ViewChild('sidenav', {static: false}) m_sidenav: any;

  dataSource = new MatTableDataSource();
  private readonly onDestroy = new Subject<void>();

  displayedColumns: any;
  dataColumnsName: any;
  dataColumnsDef = ParamActionsref_sch;
  dataColumns: any;
  timeFormat: string;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  loadingIndicator: boolean;
  cacheDatatemp: ParamActionsrefModel[] = [];

  isRegisterActionsref: boolean;
  doCreateActionsref: boolean;
  doUpdateDoc = [];
  actionsrefToUpdate: ParamActionsrefModel;
  userLangCur: string;
  reorderable = true;
  selected = [];
  pageSize = 12;
  editing = {};
  rows = [];

  gridOptions: any;
  gridApi: any;
  gridColumnApi: any;
  defaultColDef: any;
  autoGroupColumnDef: any;
  rowGroupPanelShow: any;
  localeText: any;

  actionType: string;

  actionsrefList: ParamActionsrefModel[];

  constructor(private _userService: UserService,
    private _currentRoute: ActivatedRoute,
    private _translate: TranslateService,
    private _wksCentralService: WksCentralService,
    private modalService: BsModalService,
    private _dialog: MatDialog,
    private fb: FormBuilder) {
      this._translate.onLangChanged.subscribe(() => {
        this.translateLabels();
      }); 
    }

  ngOnInit() {
    // let labelItem = this._currentRoute.snapshot.data[0]['itemOption'];
    this.loadingIndicator = true;
    this._currentRoute.paramMap.subscribe(params => {
      this.displayType = params.get('display');
    });
    if (this.displayType === null) {
      this.displayType = 'list';
    }
    const labelItem = this._currentRoute.snapshot.data[0]['itemOption'];
    this.sidenavCollapsed = true;

    this._wksCentralService.onRegisterValid
    .pipe(takeUntil(this.onDestroy))
    .subscribe((event: any) => {
      if (event === 'cancelRegister') {
        this.toggleSidenav('');

      }
      if (event === 'closeRegisterAction') {
        this.toggleSidenav('');
        this.buildList();
      }
      if (event === 'deleteActionsRef') {
        this.buildList();
      }
    });
    /*
    this._wksCentralService.onSearchDoc
    .pipe(takeUntil(this.onDestroy))
    .subscribe((event: ParamActionsrefEvent) => {
      this.actionsrefList = event.searchResult;
      this.actionsrefToUpdate = event.searchCriteria;
      this.displayType = 'list';
      this.buildList();
      // this.getWksEquipmentList();
    });
    */
    this.optionItem = labelItem;
    this.timeFormat = this._translate.getLocalFmt('timeFormat');

    if (this.displayType === 'list') {
      this.buildList();
    }
  }
  buildList() {
    this.loadingIndicator = true;
    this.displayedColumns = [
      { field: 'actionrefLabel', headerName: this._translate.instant('actionrefLabel'), sortable: true, filter: true, resizable: true },
      { field: 'equipTypeLabel', headerName: this._translate.instant('equipTypeLabel'), sortable: true, filter: true, resizable: true },
      { field: 'workLabel', headerName: this._translate.instant('workLabel'), sortable: true, filter: true, resizable: true },
      /*{ field: 'stdCreation', headerName: this._translate.instant('stdCreation'), type: 'DateFormat',
          cellRendererParams: { array: [this.timeFormat]},
          sortable: true, filter: true, resizable: true },*/
      { field: 'stdLastupdate', headerName: this._translate.instant('stdLastupdate'), type: 'DateFormat',
          cellRendererParams: { array: [this.timeFormat]},
          sortable: true, filter: true, resizable: true },
      /*{ field: 'stdDisable', headerName: this._translate.instant('stdDisable'), type: 'DateFormat',
          cellRendererParams: { array: [this.timeFormat]},
          sortable: true, filter: true, resizable: true },*/
      { field: '', headerName: this._translate.instant('Action'),
          template: this.getActions(), width: 300
      },
    ];

    this.gridOptions = {
      columnDefs: this.getColDef(),
      enableFilter: true,
      rowDeselection: true,
      enableColResize: true,
      rowSelection: 'single',
      // navigateToNextCell: this.arrowNavigation, : non operationnel
      columnTypes: {
        'DateFormat': {cellRenderer: GridTools.dateRenderer_unixM},
        },
    };
    this.gridOptions.getRowStyle = function(params: any) {
      const data = params.data;
      if ((!data) || (data === 'undefined')) {
        return;
      }
      if (data.requestDefault) {
        // https://www.rapidtables.com/web/color/green-color.html
        return { background: '#9ACD32' };
      }

    };
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      filter: true
    };

    this.autoGroupColumnDef = {
      filterValueGetter: function(params: any) {
        const colGettingGrouped = params.colDef.showRowGroup;
        const valueForOtherCol = params.api.getValue(colGettingGrouped, params.node);
        return valueForOtherCol;
      }
    };
    this.loadingSubject.next(true);
    this.getParamActionsRefList();

    
    if (this._userService.getUserLogged() !== undefined) {
      this.userLangCur = this._userService.getUserLogged().userlang;
    }
    this.localeText = this._translate.getAgGridLabels();
  
  }
  onFilterTextBoxChanged(event: any) {
    const valueFilter = document.getElementById('filter-text-box')['value'];
    this.gridOptions.api.setQuickFilter(valueFilter);
  }
  refresh() {
    // this.getParamActionsRefList();
    this.buildList();
  }
  
  getColDef() {
    return this.displayedColumns;
  }

  getActions() {
    let actions: string;
    
    actions = '<button type="button" class="btn btn-default mat-icon-button " data-action-type="edit" data-toggle="tooltip" data-placement="left" title="' +
                  this._translate.instant('edit tooltip') + '" style=" margin-left: 5px;margin-right: 5px;" >' +
                  '<span data-action-type="edit" class="fa fa-edit" style="font-size: 20px"></span></button>' +
              '<button type="button" class="btn btn-default mat-icon-button" data-action-type="trash"  data-toggle="tooltip" data-placement="left" title="' +
                  this._translate.instant('trash tooltip') + '" style="margin-left: 5px;margin-right: 5px;" >' +
                  '<span data-action-type="trash" class="fa fa-trash" style="font-size: 20px"></span></button>'
                  ;
    
    return actions;
  }
  getParamActionsRefList() {
    this.selected = [];
    
    if (this._userService.getUserLogged() === undefined ) { return; }
    this.dataSource.data = [];
    this._wksCentralService.getParamActionsRefList(this._userService.getUserLogged().entity, this._userService.getUserLogged().userlang)
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
      data => {
        // this.dataSource.data = data.body;
        this.cacheDatatemp = [...data.body];
        this.extractColumnsName( this.cacheDatatemp);
        this.translateData();
        this.loadingSubject.next(false);
        this.loadingIndicator = false;
      },
      err => {
        console.log(err);
        if ((err.status === 500) || (err.status === 404)) {
          let titleBox: string;
          let messageBox: string;
          titleBox = 'searching actions ref';
          messageBox = 'no action ref found';
          

          titleBox = this._translate.getTranslate(titleBox);
          messageBox = this._translate.getTranslate(messageBox);
          this.displayMessageBox(titleBox, messageBox, 'ERROR', 'alertWks', '', null );
        }
      }
    );
  }
  translateData() {
    this.dataSource.data = [];
    const localArray = [...this.cacheDatatemp];
    for (const localData of localArray ) {
      let langLabels;
      localData.equipTypeLabel = this._translate.getTranslate(localData.equipType);
      // localData.workLabel = this._translate.getTranslate(localData.workLabel);

      langLabels = localData.langLabels;
      if (langLabels !== null ) {
        for (const langLabel of langLabels) {
          if (langLabel.labelLang === this._translate.getCurrentLang()) {
            localData.actionrefLabel =  langLabel.labelText;
            break;
          }
        }
      }
      langLabels = localData.paramWorksRates.langLabels;
      if (langLabels !== null ) {
        for (const langLabel of langLabels) {
          if (langLabel.labelLang === this._translate.getCurrentLang()) {
            localData.workLabel =  langLabel.labelText;
            break;
          }
        }
      }
      this.dataSource.data.push(localData);
    }
  }
  
  displayMessageBox(_titleBox: string, _messageBox: string, _messageType: string, _typeDialog: string, _actionCur: string, dataCur: any) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: 1,
      title: _titleBox,
      typeDialog: _typeDialog,
      panelClass: 'stdTheme',
      contentMessage: _messageBox,
      data1: '',
      data2: '',
      messageType: _messageType

      };

    const dialogRef = this._dialog.open(ModalCommonComponent, dialogConfig);

    dialogRef.afterClosed()
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
      data => {
        // console.log('Dialog output:', data);
        if (( data === 'okAction') && (_actionCur === 'removeActionsRef')) {
          this.deleteActionsRefOK(dataCur);
        }
      });

  }


  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // params.api.sizeColumnsToFit();
  }
  public onRowClicked(e: any) {
    if (e.event.target !== undefined) {
      const selectedRow = this.gridApi.getSelectedRows();
        const data = e.data;
        if ((!data) || (data === 'undefined')) { return; }
        const actionGrid = e.event.target.getAttribute('data-action-type');

        switch (actionGrid) {
            case 'edit': {
                this.editActionsRef(data);
                break;
            }
            case 'trash': {
                this.deleteActionsRef(data);
                break;
            }
        }
    }
  }
  onSelectionChanged() {
    const selectedRow = this.gridApi.getSelectedRows();
    // console.log('Row selected : ' + selectedRow );

  }
  extractColumnsName(_dataArray: Array<any>) {
    if (!_dataArray[0]) {
      return null;
    }
    // init update and save mark
    this.doUpdateDoc = [...Array(_dataArray.length)].map(x => false);
    this.dataColumnsName = Object.keys(_dataArray[0]);
    this.dataColumns = CommonMethods.optionsSelected(this._translate, this.dataColumnsDef,
    this.dataColumnsName, this.displayedColumns, false);
    // console.log('Columns current : ', this.dataColumns);
  }
  
  toggleSidenav(_arg: string) {

    this.isRegisterActionsref = false;
    if (this.displayType === 'newsearch') {
      return;
    }

    if (_arg === 'registerActionsRef') {
      this.isRegisterActionsref = true;
    }
    this.sidenavCollapsed = !this.sidenavCollapsed;
    if (this.sidenavCollapsed) {
      try {
        this.m_sidenav.close();
      } catch (error) {
      } finally { }
    } else {
      try {
        this.m_sidenav.open();
      } catch (error) {
      } finally { }
    }
  }
  editActionsRefAgGrid() {

    const selectedRow = this.gridApi.getSelectedRows();
    this.actionsrefToUpdate = selectedRow;
    

    this.actionType = 'update';

    this.doCreateActionsref = false;
    this.toggleSidenav('registerActionsRef');
  }
  editActionsRef(row: ParamActionsrefModel) {
    this.actionsrefToUpdate = row;

    this.actionType = 'update';

    this.doCreateActionsref = false;
    this.toggleSidenav('registerActionsRef');
  }
  addActionRef() {
  
    this.doCreateActionsref = true;
    this.actionType = 'add';
    this.actionsrefToUpdate = undefined;
    this.toggleSidenav('registerActionsRef');
  }
  translateLabels() {

    if (this.displayedColumns === undefined) {
      return;
    }
    const nbCol = this.displayedColumns.length;
    const localColumns = this.displayedColumns;
    this.displayedColumns = [];
    for (let i = 0; i < nbCol; i++) {
      const lTmp = localColumns[i];

      this.displayedColumns.push({
        'prop': lTmp.prop,
        'name': this._translate.getTranslate(lTmp.prop),
        'isDate': false
      });
    }
  }
  deleteActionsRef(row: ParamActionsrefModel) {
    // console.log('deleteEntity Row clicked: ', row);
    let titleBox: string;
    let messageBox: string;
    titleBox = 'deleting work rate';
    

    titleBox = this._translate.getTranslate(titleBox);
    messageBox = row.actionrefLabel;

    this.displayMessageBox(titleBox, messageBox, 'WARNING', 'confirmAction', 'removeActionsRef', row );

  }
  deleteActionsRefOK(row: ParamActionsrefModel) {

      this._wksCentralService.saveParamActionsRef(row, 'deleteActionsRef')
      .subscribe(
        () => {
            this._wksCentralService.onRegisterValid.emit('deleteActionsRef');
        },
        () => {

        }
      );
    
  }
}
